import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    urlProd: 'https://colonoselcampestre.com/api',
    urlSandbox: 'http://localhost/api-fraccionamientos',
    // control de la sesion
    token: '',
    idUsuario: '',
    tipoUsuario: '',
    ciw: '',
    emailUsuario: '',
    // api de paypal
    paypal: {
      clientId: '',
      secret: '',
      testClientId: '',
      testSecred: '',
      modo_prueba:''
    },
    // api de mercado pago
    mercadoPago: {
      key: '',
      token: '',
      testKey: '',
      testToken: '',
      modo_prueba: ''
    },
  },
  mutations: {
    setUsuario(state, usuario) {
      state.token = usuario.token
      state.idUsuario = usuario.idUsuario
      state.tipoUsuario = usuario.tipoUsuario
      state.ciw = usuario.ciw
      state.emailUsuario = usuario.emailUsuario
    },
    setPaypal(state, paypal) {
      state.paypal.clientId = paypal.clientId
      state.paypal.secret = paypal.secret
      state.paypal.testClientId = paypal.testClientId
      state.paypal.testSecred = paypal.testSecred
      state.paypal.modo_prueba = paypal.modo_prueba
    },
    setMercadoPago(state, mercadoPago) {
      state.mercadoPago.key = mercadoPago.key
      state.mercadoPago.token = mercadoPago.token
      state.mercadoPago.testKey = mercadoPago.testKey
      state.mercadoPago.testToken = mercadoPago.testToken
      state.mercadoPago.modo_prueba = mercadoPago.modo_prueba
    }
  },
  actions: {
    cargarLocalStorage({commit, state}) {
      if (localStorage.getItem('usuario')) {
        let usuario = JSON.parse(localStorage.getItem('usuario'))
        commit('setUsuario', usuario)
      }

      // cargamos parametros
      if ( ["localhost", "127.0.0.1", ""].includes(window.location.hostname) ) {
          var url = state.urlSandbox
      } else {
          var url = state.urlProd
      }

      var formData = new FormData();
      formData.append("accion", "mostrarDatos");
      formData.append("tabla", "parametros");
      formData.append("limite", 1);
      
      axios.post(`${url}/ajax/ajax.generico.php`, formData)
      .then((res) => {
          let pay = {
            clientId: res.data.paypal_clientId,
            secret: res.data.paypal_secret,
            testClientId: res.data.paypal_testClientId,
            testSecred: res.data.paypal_testSecret,
            modo_prueba: res.data.paypal_modoPrueba
          }

          commit('setPaypal', pay)

          let mercado = {
            key: res.data.mercadoPago_key,
            token: res.data.mercadoPago_token,
            testKey: res.data.mercadoPago_testKey,
            testToken: res.data.mercadoPago_testToken,
            modo_prueba: res.data.mercadoPago_modoPrueba
          }

          commit('setMercadoPago', mercado)
      });
    },
    updUsuario({commit}, usuario) {
      commit('setUsuario', usuario)
      localStorage.setItem('usuario', JSON.stringify(usuario))
    }
  },
  getters: {
    usuarioAutenticado(state) {
      return !!state.token
    }
  },
  modules: {
  }
})
